<template>
  <div class="result-wrapper">
    <DetalhesDescredenciado
      v-if="showDescredenciado"
      :bloqueado="bloqueado"
      :substituto="substituto"
      @close="close"
    />
    <div :style="{display: showDescredenciado ? 'none' : ''}">
      <h3>Resultados da busca ({{total||0}})</h3>
      <Filtros @change="(filters) => $emit('changeFilters', filters)" />
      <div v-if="descredenciados.length > 0">
        <DescredenciadoCard
          v-for="descredenciado in descredenciados"
          :key="descredenciado.id"
          :descredenciado="descredenciado"
          @show="show"
        />
      </div>
      <div v-else>
        <p>Nenhum descredenciado encontrado.</p>
      </div>
    </div>
  </div>
</template>
<script>
import DescredenciadoCard from './DescredenciadoCard.vue'
import DetalhesDescredenciado from './DetalhesDescredenciado.vue'
import Filtros from './Filtros.vue'

export default {
  name: 'ListaDescredenciados',
  components: { DetalhesDescredenciado, DescredenciadoCard, Filtros },
  props: {
    descredenciados: {
      type: Array
    },
    total: {
      type: Number
    }
  },
  watch: {
    descredenciados () {
      this.close()
    }
  },
  data () {
    return {
      showDescredenciado: false,
      bloqueado: null,
      substituto: null
    }
  },
  methods: {
    show ({ bloqueado = null, substituto = null }) {
      this.showDescredenciado = true
      this.substituto = substituto
      this.bloqueado = bloqueado
    },
    close () {
      this.showDescredenciado = false
      this.substituto = null
      this.bloqueado = null
    }
  }
}
</script>
<style scoped>
.result-wrapper {
  margin-top: 24px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>
